import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import storage from "redux-persist-indexeddb-storage";
import {
  persistStore, persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import accountSlice from "./slices/accountSlice";
import userSlice from "./slices/userSlice";
import siteSlice from "./slices/siteSlice";
import betSettingsSlice from "./slices/betSettingsSlice";
import matchesReducer from "./slices/matchSlice";
import marketOddsReducer from "./slices/fullmarketSlice";
import betsReducer from "./slices/betsSlice";
import bookmakerOddsReducer from "./slices/bookmakerSlice";
import fancyOddsReducer from "./slices/fancySlice";
import sidebarReducer from "./slices/sidebarSlice";
import authReducer from '../../GugoExchangeSrc/src/redux/authSlice'
import activeReducer from '../../GugoExchangeSrc/src/redux/activeSlice'
import masterReducer from '../../GugoExchangeSrc/src/redux/masterSlice';
import casinoReducer from "./slices/casinoSlice";
import intCasinoReducer from "./slices/intCasinoSlice";
import greyhoundReducer from "./slices/greyhoundSlice";
import horseReducer from "./slices/horseSlice";
import authModalSlice from "./slices/authModalSlice";
import placeBetReducer from "./slices/placeBetSlice";
import siteCasinoReducer from "./slices/siteCasinoSlice";
import routeReducer from "./slices/routeSlice";

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Combine reducers
const rootReducer = combineReducers({
  authModal: authModalSlice,
  site: siteSlice,
  betSettingsSlice: betSettingsSlice,
  account: accountSlice,
  user: userSlice,
  matches: matchesReducer,
  marketOdds: marketOddsReducer,
  bookmakerOdds: bookmakerOddsReducer,
  fancyOdds: fancyOddsReducer,
  bets: betsReducer,
  sidebar: sidebarReducer,
  casino: casinoReducer,
  siteCasino: siteCasinoReducer,
  intCasino: intCasinoReducer,
  greyhound: greyhoundReducer,
  horse: horseReducer,
  auth: authReducer,
  active: activeReducer,
  master: masterReducer,
  placeBet: placeBetReducer,
  route: routeReducer
});

const persistConfig = {
  key: "root",
  storage: storage("root"),
  whitelist: ["account", "user", "marketOdds", "bookmakerOdds", "horse", "greyhound", "site", "matches","betSettingsSlice", "intCasino"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: false,
    }),
    sagaMiddleware,
  ],
  devTools: import.meta.env.PROD ? false : true
});

export const persistor = persistStore(store);

export default store;
